import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import NotebookLayout from "./NotebookLayout";
import { useGetNotebook } from "../tars-hooks";
import { invalidateTarsNotebooksList } from "../tars-hooks/useGetNotebooks";
import { useStore } from "../../../helpers";

const NotebookDetailsPage = () => {
  const { notebookId } = useParams();
  const queryClient = useQueryClient();
  const { tarsStore } = useStore();
  const id = notebookId != null ? Number(notebookId) : null;
  const { data: notebook, isLoading, isError } = useGetNotebook(id);

  useEffect(() => {
    return () => {
      tarsStore.clearSelectedNotebook();
      invalidateTarsNotebooksList(queryClient);
    };
  }, [tarsStore, queryClient]);

  useEffect(() => {
    if (notebook) tarsStore.setSelectedNotebook(notebook);
  }, [notebook, tarsStore]);

  if (!notebookId) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-70px)] p-6 text-gray-600">
        Invalid notebook
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-70px)] gap-3 p-6 text-gray-600">
        <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
        <span>Loading notebook...</span>
      </div>
    );
  }

  if (isError || !notebook) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-70px)] gap-2 p-6 text-gray-600">
        <p>Unable to load this notebook.</p>
        <p className="text-sm text-gray-500">Please try again later.</p>
      </div>
    );
  }

  return <NotebookLayout />;
};

export default NotebookDetailsPage;
